import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import '../styles/EditJobCard.css';
import { getStorage } from 'firebase/storage';
import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

function EditJobCard() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [card, setCard] = useState(null);

  const [destination, setDestination] = useState('Abu Dhabi');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [age, setAge] = useState('');
  const [audiogram, setAudiogram] = useState({ Left: {}, Right: {} });
  const [hearingModel, setHearingModel] = useState('');
  const [colorSelection, setColorSelection] = useState([]);
  const [shellStyle, setShellStyle] = useState({});
  const [earmoldMaterial, setEarmoldMaterial] = useState({});
  const [earmoldColor, setEarmoldColor] = useState('');
  const [venting, setVenting] = useState({});
  const [finish, setFinish] = useState('');
  const [shellOptions, setShellOptions] = useState({});
  const [wirelessAccessories, setWirelessAccessories] = useState({});
  const [audiologistName, setAudiologistName] = useState('');
  const [technicianName, setTechnicianName] = useState('');
  const [notes, setNotes] = useState('');
  const [attachments, setAttachments] = useState([]);


  useEffect(() => {
    const fetchCard = async () => {
      const docRef = doc(db, 'jobCards', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setCard(data);
        setDestination(data.destination || 'Abu Dhabi');
        setFirstName(data.firstName || '');
        setLastName(data.lastName || '');
        setAge(data.age || '');
        setAudiogram(data.audiogram || { Left: {}, Right: {} });
        setHearingModel(data.hearingModel || '');
        setColorSelection(data.colorSelection || []);
        setShellStyle(data.shellStyle || {});
        setEarmoldMaterial(data.earmoldMaterial || {});
        setEarmoldColor(data.earmoldColor || '');
        setVenting(data.venting || {});
        setFinish(data.finish || '');
        setShellOptions(data.shellOptions || {});
        setWirelessAccessories(data.wirelessAccessories || {});
        setAudiologistName(data.audiologistName || '');
        setTechnicianName(data.technicianName || '');
        setNotes(data.notes || '');
      }
      setLoading(false);
    };
    fetchCard();
  }, [id]);

  const handleCheckbox = (setter, name) => {
    setter(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleColorToggle = (color) => {
    setColorSelection(prev =>
      prev.includes(color) ? prev.filter(c => c !== color) : [...prev, color]
    );
  };

const handleSave = async () => {
  const uploadedURLs = []; // ✅ هذا السطر مهم جدًا

  if (attachments.length > 0) {
    const serial = card.serial || `SN-${Date.now()}`;
    for (let i = 0; i < attachments.length; i++) {
      const file = attachments[i];
      const fileRef = ref(storage, `attachments/${serial}/${file.name}`);
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      uploadedURLs.push(url);
    }
  }

  const docRef = doc(db, 'jobCards', id);
  await updateDoc(docRef, {
    destination,
    firstName,
    lastName,
    age,
    audiogram,
    hearingModel,
    colorSelection,
    shellStyle,
    earmoldMaterial,
    earmoldColor,
    venting,
    finish,
    shellOptions,
    wirelessAccessories,
    audiologistName,
    technicianName,
    notes,
    attachments: uploadedURLs.length > 0 ? uploadedURLs : card.attachments || [],
    lastUpdated: serverTimestamp(),
  });

  alert('Job Card updated successfully.');
  navigate('/view-job-cards');
};


  if (loading) return <p>Loading...</p>;

  return (
    <div className="editjobcard-container">
      <h1 className="editjobcard-title">Edit Job Card</h1>

      <h2 className="editjobcard-step">Step 1: Ship to</h2>
      <select className="editjobcard-input" value={destination} onChange={e => setDestination(e.target.value)}>
        {[ 'Abu Dhabi', 'Al Ain', 'RAK', 'Al Kuwait Hospital', 'Saqr Hospital', 'Gergash Hospital', 'Tarapichi Hospital' ].map(dest => (
          <option key={dest} value={dest}>{dest}</option>
        ))}
      </select>

      <h2 className="editjobcard-step">Step 2: Patient Information</h2>
      <div className="editjobcard-row">
        <input className="editjobcard-input" type="text" placeholder="First Name" value={firstName} onChange={e => setFirstName(e.target.value)} />
        <input className="editjobcard-input" type="text" placeholder="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} />
        <input className="editjobcard-input" type="text" placeholder="Age" value={age} onChange={e => setAge(e.target.value)} />
      </div>

      <h3 className="editjobcard-subtitle">Patient Audiogram</h3>
      <table className="edit-audiogram-table">
        <thead>
          <tr>
            <th></th>
            {[ '250', '500', '1000', '2000', '3000', '4000' ].map(freq => <th key={freq}>{freq} Hz</th>)}
          </tr>
        </thead>
        <tbody>
          {[ 'Left', 'Right' ].map(side => (
            <tr key={side}>
              <td>{side}</td>
              {[ '250', '500', '1000', '2000', '3000', '4000' ].map(freq => (
                <td key={freq}>
                  <input
                    className="edit-audiogram-input"
                    type="text"
                    value={audiogram[side]?.[freq] || ''}
                    onChange={e => setAudiogram(prev => ({
                      ...prev,
                      [side]: { ...prev[side], [freq]: e.target.value }
                    }))}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <h2 className="editjobcard-step">Step 3: Hearing Instrument Selection</h2>
      <input
        type="text"
        className="editjobcard-input"
        placeholder="Please type hearing aid model"
        value={hearingModel}
        onChange={e => setHearingModel(e.target.value)}
      />

      <h3 className="editjobcard-subtitle">Color</h3>
      <div className="edit-color-options">
        {[ 'Sand (R8)', 'Amber (P2)', 'Espresso (P4)', 'Platinum (P6)', 'Pewter (P7)', 'Charcoal (P8)' ].map(color => (
          <label key={color} className="edit-color-checkbox">
            <input
              type="checkbox"
              checked={colorSelection.includes(color)}
              onChange={() => handleColorToggle(color)}
            /> {color}
          </label>
        ))}
      </div>

      {/* Step 4 - مطابقة لتصميم CreateJobCard */}
      <h2 className="jobcard-step">Step 4: Custom Options</h2>
      <div className="checkbox-group">
        <div className="checkbox-section">
          <label className="checkbox-group-title">Shell Style</label>
          <span className="l-r-label">L  R</span>
          {["Full shell carved (SC)", "Full shell uncarved (SU)", "Half-shell (HC)", "Skeleton (SK)", "Semi skeleton (SS)", "Canal lock (CL)", "Canal (CU)", "CROS (CB)", "SlimTip, hollow (acrylic)", "SlimTip, soft solid (silicone)"].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setShellStyle, `L-${opt}`)} checked={!!shellStyle[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setShellStyle, `R-${opt}`)} checked={!!shellStyle[`R-${opt}`]} /> {opt}
            </div>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Earmold Material</label>
          <span className="l-r-label">L  R</span>
          {["Acrylic (AC)", "Silicone (S70)"].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setEarmoldMaterial, `L-${opt}`)} checked={!!earmoldMaterial[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setEarmoldMaterial, `R-${opt}`)} checked={!!earmoldMaterial[`R-${opt}`]} /> {opt}
            </div>
          ))}

          <label className="checkbox-group-title">Earmold Color</label>
          <input type="text" className="jobcard-input" placeholder="Type mold color" value={earmoldColor} onChange={e => setEarmoldColor(e.target.value)} />
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Venting</label>
          <span className="l-r-label">L  R</span>
          {["Small 2.0 mm", "Medium 2.5 mm", "Large 3.0 mm", "No vent (X)", "Parallel (circular) 1.2mm", "Styled/Custom (3L)", "IROS A/Semi-Iros/3.0mm", "IROS B/Full-Iros/3.0mm", "Pressure vent 1.2mm"].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setVenting, `L-${opt}`)} checked={!!venting[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setVenting, `R-${opt}`)} checked={!!venting[`R-${opt}`]} /> {opt}
            </div>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Finish</label>
          {["Gloss (HC)", "No Lacquer (NL)"].map(opt => (
            <label key={opt} className="radio-group">
              <input type="radio" name="finish" value={opt} checked={finish === opt} onChange={e => setFinish(e.target.value)} /> {opt}
            </label>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Shell Options</label>
          <span className="l-r-label">L  R</span>
          {["Removal filament (RF)", "Canal lock (CL)", "Skeleton Lock (SL)"].map((opt, i) => (
            <div className="l-r-pair" key={i}>
              <input type="checkbox" onChange={() => handleCheckbox(setShellOptions, `L-${opt}`)} checked={!!shellOptions[`L-${opt}`]} />
              <input type="checkbox" onChange={() => handleCheckbox(setShellOptions, `R-${opt}`)} checked={!!shellOptions[`R-${opt}`]} /> {opt}
            </div>
          ))}
        </div>

        <div className="checkbox-section">
          <label className="checkbox-group-title">Wireless Accessories</label>
          {["Remote Control", "TV Connector", "Partner Mic"].map(opt => (
            <label key={opt} className="checkbox-item">
              <input type="checkbox" onChange={() => handleCheckbox(setWirelessAccessories, opt)} checked={!!wirelessAccessories[opt]} /> {opt}
            </label>
          ))}
        </div>
      </div>

      <h2 className="editjobcard-step">Step 5: Staff Info & Notes</h2>
      <div className="editjobcard-row">
        <input type="text" className="editjobcard-input" placeholder="Audiologist Name" value={audiologistName} onChange={e => setAudiologistName(e.target.value)} />
        <input type="text" className="editjobcard-input" placeholder="Technician Name" value={technicianName} onChange={e => setTechnicianName(e.target.value)} />
      </div>
      <textarea
        className="editjobcard-notes"
        placeholder="Enter any important notes here..."
        value={notes}
        onChange={e => setNotes(e.target.value)}
      />

<h2 className="editjobcard-step">Step 6: Upload New Attachments</h2>
<input
  type="file"
  multiple
  onChange={(e) => setAttachments(Array.from(e.target.files))}
  className="editjobcard-input"
/>
<p style={{ fontSize: '0.9rem', color: '#555' }}>
  Existing attachments will be replaced if you upload new ones.
</p>

      <button onClick={handleSave} className="edit-save-btn">Save Changes</button>
    </div>
  );
}

export default EditJobCard;